import React from "react";

function ProjectDescription(props) {
  let stack = undefined;
  if (props.stack) {
    stack = props.stack.map((value, index) => (
      <li key={index}> ⚪ &nbsp; {value}</li>
    ))
  }
  return (
    <div className="resume-item">
      <h5 className={props.title ? "resume-title" : "resume-no-title"}>
        {props.title}
      </h5>
      <p>
        <em>{props.date}</em>
      </p>
      <p className="text-justify">
        {props.description}
      </p>
      <ul>
        {stack}
      </ul>
    </div>
  );
}

export default ProjectDescription;
